import { render, staticRenderFns } from "./DashboardWidgetMessagesNewItem.vue?vue&type=template&id=5b0c0462&lang=pug&"
import script from "./DashboardWidgetMessagesNewItem.vue?vue&type=script&lang=js&"
export * from "./DashboardWidgetMessagesNewItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports